// import { useState } from "react";
// import { motion } from "framer-motion";
// import { FaShippingFast, FaCreditCard, FaCheckCircle } from "react-icons/fa";
// import Footer from "../components/Footer";
// import Navbar from "../components/Navbar";

// const steps = [
//   { title: "Shipping Details", icon: <FaShippingFast /> },
//   { title: "Payment Method", icon: <FaCreditCard /> },
//   { title: "Order Confirmation", icon: <FaCheckCircle /> },
// ];

// const CheckoutPage = () => {
//   const [step, setStep] = useState(0);

//   const nextStep = () => setStep((prev) => Math.min(prev + 1, steps.length - 1));
//   const prevStep = () => setStep((prev) => Math.max(prev - 1, 0));

//   return (
//     <div className="bg-gray-100 min-h-screen flex flex-col">
//       <Navbar />
//       <div className="flex flex-col items-center p-6 pt-20 max-w-7xl mx-auto w-full">
//         <motion.h1
//           className="text-4xl md:text-5xl font-extrabold text-blue-700 mb-8 md:mb-12"
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           Checkout
//         </motion.h1>

//         <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-6 md:mb-8 w-full px-4">
//           {steps.map((s, index) => (
//             <motion.div
//               key={index}
//               className={`flex flex-col items-center p-4 md:p-6 rounded-2xl shadow-lg cursor-pointer transition-all duration-300 flex-1 text-center min-w-[120px] md:min-w-[180px] max-w-xs ${
//                 step === index ? "bg-blue-600 text-white scale-105" : "bg-white border border-gray-300"
//               }`}
//               onClick={() => setStep(index)}
//               whileHover={{ scale: 1.05 }}
//             >
//               <div className="text-3xl md:text-4xl mb-2">{s.icon}</div>
//               <span className="text-sm md:text-lg font-semibold">{s.title}</span>
//             </motion.div>
//           ))}
//         </div>

//         <div className="w-full max-w-4xl bg-white p-6 md:p-10 shadow-xl rounded-2xl min-h-[250px]">
//           <motion.div
//             key={step}
//             initial={{ opacity: 0, x: 50 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: -50 }}
//             transition={{ duration: 0.5 }}
//             className="text-base md:text-lg text-gray-700 flex flex-col justify-center items-center"
//           >
//             {step === 0 && (
//               <>
//                 <p className="text-center font-medium">Enter your shipping details below:</p>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
//                   <input
//                     type="text"
//                     placeholder="Full Name"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     placeholder="Phone Number"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     placeholder="Address"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     placeholder="City"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     placeholder="State"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     placeholder="ZIP Code"
//                     className="p-3 md:p-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </>
//             )}
//             {step === 1 && (
//               <>
//                 <p className="text-center font-medium">Choose a payment method:</p>
//                 <button className="mt-4 w-full p-3 md:p-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">Credit Card</button>
//                 <button className="mt-4 w-full p-3 md:p-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">PayPal</button>
//               </>
//             )}
//             {step === 2 && (
//               <>
//                 <motion.div
//                   initial={{ scale: 0 }}
//                   animate={{ scale: 1 }}
//                   transition={{ duration: 0.5 }}
//                   className="text-green-500 text-5xl md:text-6xl mb-4"
//                 >
//                   <FaCheckCircle />
//                 </motion.div>
//                 <p className="text-center text-lg md:text-xl font-bold text-gray-800">Order Confirmed!</p>
//                 <p className="text-center text-gray-600 mt-2">Thank you for shopping with us.</p>
//                 <button className="mt-6 px-5 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition shadow-md">Continue Shopping</button>
//               </>
//             )}
//           </motion.div>

//           <div className="flex justify-between mt-6 md:mt-8">
//             <button onClick={prevStep} disabled={step === 0} className="px-5 py-3 bg-gray-400 text-white rounded-lg shadow-md disabled:opacity-50 hover:bg-gray-500 transition">
//               Previous
//             </button>
//             <button onClick={nextStep} disabled={step === steps.length - 1} className="px-5 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition">
//               Next
//             </button>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default CheckoutPage;

import React, { useEffect } from 'react';
import { FaShoppingCart, FaTruck, FaCreditCard, FaCheckCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import api from '../axios/axios';
import Swal from 'sweetalert2';
import { setCheckoutDetails, setSelectedAddress } from '../redux/features/auth/userSlice';
import { setLoading } from '../redux/product/productSlice';
import Navbar from '../components/Navbar';
import AddressForm from '../components/checkoutComponents/AddressForm';
import CheckoutSummary from '../components/checkoutComponents/CheckoutSummaruy';
import Footer from '../components/Footer';

const Checkout = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const loading = useSelector((state) => state.user.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchCheckOutPage();
    dispatch(setSelectedAddress(null)); // Clear the selected address on mount

    return () => {
      dispatch(
        setCheckoutDetails({
          addresses: [],
          userInfo: null,
          totalFinalPrice: 0,
          checkoutItems: [],
          totalPriceWithTax: 0,
          totalTaxAmount: 0,
        })
      );
    };
  }, [dispatch]);

  const fetchCheckOutPage = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.get(`user/getCheckOut`, {
        params: {
          userId: currentUser._id,
        },
      });
      dispatch(
        setCheckoutDetails({
          addresses: response.data.addresses,
          userInfo: response.data.userInfo,
          totalFinalPrice: response.data.totalFinalPrice,
          checkoutItems: response.data.checkoutItems,
          totalPriceWithTax: response.data.totalPriceWithTax,
          totalTaxAmount: response.data.totalTaxAmount,
        })
      );
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong while fetching checkout data.',
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen py-10 bg-gray-100">
        <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-8 border border-gray-300">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Address Form */}
            <div className="w-full md:w-2/3 p-6 rounded-lg shadow-lg border border-gray-200">
              <AddressForm fetchCheckOutPage={fetchCheckOutPage} loading={loading} />
            </div>

            {/* Checkout Summary */}
            <div className="w-full md:w-2/3 p-6 rounded-lg shadow-lg border border-gray-200">
              <CheckoutSummary />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Checkout;